type Language = {
  name: string[];
  iso639_1: string;
};

type Country = {
  name: string;
  code_2: string;
};

const languages: Language[] = [
  { name: ['Abkhaz'], iso639_1: 'ab' },
  { name: ['Afar'], iso639_1: 'aa' },
  { name: ['Afrikaans'], iso639_1: 'af' },
  { name: ['Akan'], iso639_1: 'ak' },
  { name: ['Albanian'], iso639_1: 'sq' },
  { name: ['Amharic'], iso639_1: 'am' },
  { name: ['Arabic'], iso639_1: 'ar' },
  { name: ['Aragonese'], iso639_1: 'an' },
  { name: ['Armenian'], iso639_1: 'hy' },
  { name: ['Assamese'], iso639_1: 'as' },
  { name: ['Avaric'], iso639_1: 'av' },
  { name: ['Avestan'], iso639_1: 'ae' },
  { name: ['Aymara'], iso639_1: 'ay' },
  { name: ['Azerbaijani'], iso639_1: 'az' },
  { name: ['Bambara'], iso639_1: 'bm' },
  { name: ['Bashkir'], iso639_1: 'ba' },
  { name: ['Basque'], iso639_1: 'eu' },
  { name: ['Belarusian'], iso639_1: 'be' },
  { name: ['Bengali', 'Bangla'], iso639_1: 'bn' },
  { name: ['Berber'], iso639_1: '' },
  { name: ['Bihari'], iso639_1: 'bh' },
  { name: ['Bislama'], iso639_1: 'bi' },
  { name: ['Bosnian'], iso639_1: 'bs' },
  { name: ['Breton'], iso639_1: 'br' },
  { name: ['Bulgarian'], iso639_1: 'bg' },
  { name: ['Burmese'], iso639_1: 'my' },
  { name: ['Catalan', 'Valencian'], iso639_1: 'ca' },
  { name: ['Chamorro'], iso639_1: 'ch' },
  { name: ['Chechen'], iso639_1: 'ce' },
  { name: ['Chichewa', 'Chewa', 'Nyanja'], iso639_1: 'ny' },
  { name: ['Chinese'], iso639_1: 'zh' },
  { name: ['Chuvash'], iso639_1: 'cv' },
  { name: ['Cornish'], iso639_1: 'kw' },
  { name: ['Corsican'], iso639_1: 'co' },
  { name: ['Cree'], iso639_1: 'cr' },
  { name: ['Croatian'], iso639_1: 'hr' },
  { name: ['Czech'], iso639_1: 'cs' },
  { name: ['Danish'], iso639_1: 'da' },
  { name: ['Dari'], iso639_1: '' },
  { name: ['Divehi', 'Dhivehi', 'Maldivian'], iso639_1: 'dv' },
  { name: ['Dutch'], iso639_1: 'nl' },
  { name: ['Dzongkha'], iso639_1: 'dz' },
  { name: ['English'], iso639_1: 'en' },
  { name: ['Esperanto'], iso639_1: 'eo' },
  { name: ['Estonian'], iso639_1: 'et' },
  { name: ['Ewe'], iso639_1: 'ee' },
  { name: ['Faroese'], iso639_1: 'fo' },
  { name: ['Fijian'], iso639_1: 'fj' },
  { name: ['Finnish'], iso639_1: 'fi' },
  { name: ['French'], iso639_1: 'fr' },
  { name: ['Fula', 'Fulah', 'Pulaar', 'Pular'], iso639_1: 'ff' },
  { name: ['Galician'], iso639_1: 'gl' },
  { name: ['Georgian'], iso639_1: 'ka' },
  { name: ['German'], iso639_1: 'de' },
  { name: ['Greek'], iso639_1: 'el' },
  { name: ['Guaraní'], iso639_1: 'gn' },
  { name: ['Gujarati'], iso639_1: 'gu' },
  { name: ['Haitian', 'Haitian Creole'], iso639_1: 'ht' },
  { name: ['Hausa'], iso639_1: 'ha' },
  { name: ['Hebrew'], iso639_1: 'he' },
  { name: ['Herero'], iso639_1: 'hz' },
  { name: ['Hindi'], iso639_1: 'hi' },
  { name: ['Hiri Motu'], iso639_1: 'ho' },
  { name: ['Hungarian'], iso639_1: 'hu' },
  { name: ['Interlingua'], iso639_1: 'ia' },
  { name: ['Indonesian'], iso639_1: 'id' },
  { name: ['Interlingue'], iso639_1: 'ie' },
  { name: ['Irish'], iso639_1: 'ga' },
  { name: ['Igbo'], iso639_1: 'ig' },
  { name: ['Inupiaq'], iso639_1: 'ik' },
  { name: ['Ido'], iso639_1: 'io' },
  { name: ['Icelandic'], iso639_1: 'is' },
  { name: ['Italian'], iso639_1: 'it' },
  { name: ['Inuktitut'], iso639_1: 'iu' },
  { name: ['Japanese'], iso639_1: 'ja' },
  { name: ['Javanese'], iso639_1: 'jv' },
  { name: ['Kalaallisut', 'Greenlandic'], iso639_1: 'kl' },
  { name: ['Kannada'], iso639_1: 'kn' },
  { name: ['Kanuri'], iso639_1: 'kr' },
  { name: ['Kashmiri'], iso639_1: 'ks' },
  { name: ['Kazakh'], iso639_1: 'kk' },
  { name: ['Khmer'], iso639_1: 'km' },
  { name: ['Kikuyu', 'Gikuyu'], iso639_1: 'ki' },
  { name: ['Kinyarwanda'], iso639_1: 'rw' },
  { name: ['Kyrgyz'], iso639_1: 'ky' },
  { name: ['Komi'], iso639_1: 'kv' },
  { name: ['Kongo'], iso639_1: 'kg' },
  { name: ['Korean'], iso639_1: 'ko' },
  { name: ['Kurdish'], iso639_1: 'ku' },
  { name: ['Kwanyama', 'Kuanyama'], iso639_1: 'kj' },
  { name: ['Latin'], iso639_1: 'la' },
  { name: ['Luxembourgish', 'Letzeburgesch'], iso639_1: 'lb' },
  { name: ['Ganda'], iso639_1: 'lg' },
  { name: ['Limburgish', 'Limburgan', 'Limburger'], iso639_1: 'li' },
  { name: ['Lingala'], iso639_1: 'ln' },
  { name: ['Lao'], iso639_1: 'lo' },
  { name: ['Lithuanian'], iso639_1: 'lt' },
  { name: ['Luba-Katanga'], iso639_1: 'lu' },
  { name: ['Latvian'], iso639_1: 'lv' },
  { name: ['Manx'], iso639_1: 'gv' },
  { name: ['Macedonian'], iso639_1: 'mk' },
  { name: ['Malagasy'], iso639_1: 'mg' },
  { name: ['Malay'], iso639_1: 'ms' },
  { name: ['Malayalam'], iso639_1: 'ml' },
  { name: ['Maltese'], iso639_1: 'mt' },
  { name: ['Māori'], iso639_1: 'mi' },
  { name: ['Marathi (Marāṭhī)'], iso639_1: 'mr' },
  { name: ['Marshallese'], iso639_1: 'mh' },
  { name: ['Mongolian'], iso639_1: 'mn' },
  { name: ['Nauru'], iso639_1: 'na' },
  { name: ['Navajo', 'Navaho'], iso639_1: 'nv' },
  { name: ['Norwegian Bokmål'], iso639_1: 'nb' },
  { name: ['Northern Ndebele'], iso639_1: 'nd' },
  { name: ['Northern Sotho'], iso639_1: '' },
  { name: ['Nepali'], iso639_1: 'ne' },
  { name: ['Ndonga'], iso639_1: 'ng' },
  { name: ['Norwegian Nynorsk'], iso639_1: 'nn' },
  { name: ['Norwegian'], iso639_1: 'no' },
  { name: ['Nuosu'], iso639_1: 'ii' },
  { name: ['Southern Ndebele'], iso639_1: 'nr' },
  { name: ['Occitan'], iso639_1: 'oc' },
  { name: ['Ojibwe', 'Ojibwa'], iso639_1: 'oj' },
  {
    name: ['Old Church Slavonic', 'Church Slavonic', 'Old Bulgarian'],
    iso639_1: 'cu',
  },
  { name: ['Oromo'], iso639_1: 'om' },
  { name: ['Oriya'], iso639_1: 'or' },
  { name: ['Ossetian', 'Ossetic'], iso639_1: 'os' },
  { name: ['Panjabi', 'Punjabi'], iso639_1: 'pa' },
  { name: ['Pāli'], iso639_1: 'pi' },
  { name: ['Persian', 'Farsi'], iso639_1: 'fa' },
  { name: ['Polish'], iso639_1: 'pl' },
  { name: ['Pashto', 'Pushto'], iso639_1: 'ps' },
  { name: ['Portuguese'], iso639_1: 'pt' },
  { name: ['Quechua'], iso639_1: 'qu' },
  { name: ['Romansh'], iso639_1: 'rm' },
  { name: ['Kirundi'], iso639_1: 'rn' },
  { name: ['Romanian'], iso639_1: 'ro' },
  { name: ['Russian'], iso639_1: 'ru' },
  { name: ['Sanskrit (Saṁskṛta)'], iso639_1: 'sa' },
  { name: ['Sardinian'], iso639_1: 'sc' },
  { name: ['Sindhi'], iso639_1: 'sd' },
  { name: ['Northern Sami'], iso639_1: 'se' },
  { name: ['Samoan'], iso639_1: 'sm' },
  { name: ['Sango'], iso639_1: 'sg' },
  { name: ['Serbian'], iso639_1: 'sr' },
  { name: ['Scottish Gaelic', 'Gaelic'], iso639_1: 'gd' },
  { name: ['Shona'], iso639_1: 'sn' },
  { name: ['Sinhala', 'Sinhalese'], iso639_1: 'si' },
  { name: ['Slovak'], iso639_1: 'sk' },
  { name: ['Slovene'], iso639_1: 'sl' },
  { name: ['Somali'], iso639_1: 'so' },
  { name: ['Southern Sotho'], iso639_1: 'st' },
  { name: ['Spanish', 'Castilian'], iso639_1: 'es' },
  { name: ['Sundanese'], iso639_1: 'su' },
  { name: ['Swahili'], iso639_1: 'sw' },
  { name: ['Swati'], iso639_1: 'ss' },
  { name: ['Swedish'], iso639_1: 'sv' },
  { name: ['Tamil'], iso639_1: 'ta' },
  { name: ['Telugu'], iso639_1: 'te' },
  { name: ['Tajik'], iso639_1: 'tg' },
  { name: ['Thai'], iso639_1: 'th' },
  { name: ['Tigrinya'], iso639_1: 'ti' },
  { name: ['Tibetan Standard', 'Tibetan', 'Central'], iso639_1: 'bo' },
  { name: ['Turkmen'], iso639_1: 'tk' },
  { name: ['Tagalog'], iso639_1: 'tl' },
  { name: ['Filipino'], iso639_1: '' },
  { name: ['Tswana'], iso639_1: 'tn' },
  { name: ['Tonga (Tonga Islands)'], iso639_1: 'to' },
  { name: ['Turkish'], iso639_1: 'tr' },
  { name: ['Tsonga'], iso639_1: 'ts' },
  { name: ['Tatar'], iso639_1: 'tt' },
  { name: ['Twi'], iso639_1: 'tw' },
  { name: ['Tahitian'], iso639_1: 'ty' },
  { name: ['Uyghur', 'Uighur'], iso639_1: 'ug' },
  { name: ['Ukrainian'], iso639_1: 'uk' },
  { name: ['Urdu'], iso639_1: 'ur' },
  { name: ['Uzbek'], iso639_1: 'uz' },
  { name: ['Venda'], iso639_1: 've' },
  { name: ['Vietnamese'], iso639_1: 'vi' },
  { name: ['Volapük'], iso639_1: 'vo' },
  { name: ['Walloon'], iso639_1: 'wa' },
  { name: ['Welsh'], iso639_1: 'cy' },
  { name: ['Wolof'], iso639_1: 'wo' },
  { name: ['Western Frisian'], iso639_1: 'fy' },
  { name: ['Xhosa'], iso639_1: 'xh' },
  { name: ['Yiddish'], iso639_1: 'yi' },
  { name: ['Yoruba'], iso639_1: 'yo' },
  { name: ['Zhuang', 'Chuang'], iso639_1: 'za' },
  { name: ['Zulu'], iso639_1: 'zu' },
  { name: ['Achinese'], iso639_1: '' },
  { name: ['Acoli'], iso639_1: '' },
  { name: ['Adangme'], iso639_1: '' },
  { name: ['Adyghe', ' Adygei'], iso639_1: '' },
  { name: ['Afro-Asiatic languages'], iso639_1: '' },
  { name: ['Afrihili'], iso639_1: '' },
  { name: ['Ainu'], iso639_1: '' },
  { name: ['Akkadian'], iso639_1: '' },
  { name: ['Aleut'], iso639_1: '' },
  { name: ['Algonquian languages'], iso639_1: '' },
  { name: ['Southern Altai'], iso639_1: '' },
  { name: ['English, Old (ca.450-1100)'], iso639_1: '' },
  { name: ['Angika'], iso639_1: '' },
  { name: ['Apache languages'], iso639_1: '' },
  {
    name: ['Official Aramaic (700-300 BCE)', ' Imperial Aramaic (700-300 BCE)'],
    iso639_1: '',
  },
  { name: ['Mapudungun', ' Mapuche'], iso639_1: '' },
  { name: ['Arapaho'], iso639_1: '' },
  { name: ['Artificial languages'], iso639_1: '' },
  { name: ['Arawak'], iso639_1: '' },
  { name: ['Asturian', ' Bable', ' Leonese', ' Asturleonese'], iso639_1: '' },
  { name: ['Athapascan languages'], iso639_1: '' },
  { name: ['Australian languages'], iso639_1: '' },
  { name: ['Awadhi'], iso639_1: '' },
  { name: ['Banda languages'], iso639_1: '' },
  { name: ['Bamileke languages'], iso639_1: '' },
  { name: ['Baluchi', 'Balochi'], iso639_1: '' },
  { name: ['Balinese'], iso639_1: '' },
  { name: ['Basa'], iso639_1: '' },
  { name: ['Baltic languages'], iso639_1: '' },
  { name: ['Beja', ' Bedawiyet'], iso639_1: '' },
  { name: ['Bemba'], iso639_1: '' },
  { name: ['Bhojpuri'], iso639_1: '' },
  { name: ['Bikol'], iso639_1: '' },
  { name: ['Bini', ' Edo'], iso639_1: '' },
  { name: ['Siksika'], iso639_1: '' },
  { name: ['Bantu languages'], iso639_1: '' },
  { name: ['Braj'], iso639_1: '' },
  { name: ['Batak languages'], iso639_1: '' },
  { name: ['Buriat'], iso639_1: '' },
  { name: ['Buginese'], iso639_1: '' },
  { name: ['Blin', ' Bilin'], iso639_1: '' },
  { name: ['Caddo'], iso639_1: '' },
  { name: ['Central American Indian languages'], iso639_1: '' },
  { name: ['Galibi Carib'], iso639_1: '' },
  { name: ['Caucasian languages'], iso639_1: '' },
  { name: ['Cebuano'], iso639_1: '' },
  { name: ['Celtic languages'], iso639_1: '' },
  { name: ['Chibcha'], iso639_1: '' },
  { name: ['Chagatai'], iso639_1: '' },
  { name: ['Chuukese'], iso639_1: '' },
  { name: ['Mari'], iso639_1: '' },
  { name: ['Chinook jargon'], iso639_1: '' },
  { name: ['Choctaw'], iso639_1: '' },
  { name: ['Chipewyan', ' Dene Suline'], iso639_1: '' },
  { name: ['Cherokee'], iso639_1: '' },
  { name: ['Cheyenne'], iso639_1: '' },
  { name: ['Chamic languages'], iso639_1: '' },
  { name: ['Coptic'], iso639_1: '' },
  { name: ['Creoles and pidgins, English based'], iso639_1: '' },
  { name: ['Creoles and pidgins, French-based'], iso639_1: '' },
  { name: ['Creoles and pidgins, Portuguese-based'], iso639_1: '' },
  { name: ['Crimean Tatar', ' Crimean Turkish'], iso639_1: '' },
  { name: ['Creoles and pidgins'], iso639_1: '' },
  { name: ['Kashubian'], iso639_1: '' },
  { name: ['Cushitic languages'], iso639_1: '' },
  { name: ['Dakota'], iso639_1: '' },
  { name: ['Dargwa'], iso639_1: '' },
  { name: ['Land Dayak languages'], iso639_1: '' },
  { name: ['Delaware'], iso639_1: '' },
  { name: ['Slave (Athapascan)'], iso639_1: '' },
  { name: ['Dogrib'], iso639_1: '' },
  { name: ['Dinka'], iso639_1: '' },
  { name: ['Dogri'], iso639_1: '' },
  { name: ['Dravidian languages'], iso639_1: '' },
  { name: ['Lower Sorbian'], iso639_1: '' },
  { name: ['Duala'], iso639_1: '' },
  { name: ['Dutch, Middle (ca.1050-1350)'], iso639_1: '' },
  { name: ['Dyula'], iso639_1: '' },
  { name: ['Efik'], iso639_1: '' },
  { name: ['Egyptian (Ancient)'], iso639_1: '' },
  { name: ['Ekajuk'], iso639_1: '' },
  { name: ['Elamite'], iso639_1: '' },
  { name: ['English, Middle (1100-1500)'], iso639_1: '' },
  { name: ['Ewondo'], iso639_1: '' },
  { name: ['Fang'], iso639_1: '' },
  { name: ['Fanti'], iso639_1: '' },
  { name: ['Finno-Ugrian languages'], iso639_1: '' },
  { name: ['Fon'], iso639_1: '' },
  { name: ['French, Middle (ca.1400-1600)'], iso639_1: '' },
  { name: ['French, Old (842-ca.1400)'], iso639_1: '' },
  { name: ['Northern Frisian'], iso639_1: '' },
  { name: ['Eastern Frisian'], iso639_1: '' },
  { name: ['Friulian'], iso639_1: '' },
  { name: ['Ga'], iso639_1: '' },
  { name: ['Gayo'], iso639_1: '' },
  { name: ['Gbaya'], iso639_1: '' },
  { name: ['Germanic languages'], iso639_1: '' },
  { name: ['Geez'], iso639_1: '' },
  { name: ['Gilbertese'], iso639_1: '' },
  { name: ['German, Middle High (ca.1050-1500)'], iso639_1: '' },
  { name: ['German, Old High (ca.750-1050)'], iso639_1: '' },
  { name: ['Gondi'], iso639_1: '' },
  { name: ['Gorontalo'], iso639_1: '' },
  { name: ['Gothic'], iso639_1: '' },
  { name: ['Grebo'], iso639_1: '' },
  { name: ['Greek, Ancient (to 1453)'], iso639_1: '' },
  { name: ['Swiss German', ' Alemannic', ' Alsatian'], iso639_1: '' },
  { name: ["Gwich'in"], iso639_1: '' },
  { name: ['Haida'], iso639_1: '' },
  { name: ['Hawaiian'], iso639_1: '' },
  { name: ['Hiligaynon'], iso639_1: '' },
  { name: ['Himachali languages', ' Western Pahari languages'], iso639_1: '' },
  { name: ['Hittite'], iso639_1: '' },
  { name: ['Hmong', ' Mong'], iso639_1: '' },
  { name: ['Upper Sorbian'], iso639_1: '' },
  { name: ['Hupa'], iso639_1: '' },
  { name: ['Iban'], iso639_1: '' },
  { name: ['Ijo languages'], iso639_1: '' },
  { name: ['Iloko'], iso639_1: '' },
  { name: ['Indic languages'], iso639_1: '' },
  { name: ['Indo-European languages'], iso639_1: '' },
  { name: ['Ingush'], iso639_1: '' },
  { name: ['Iranian languages'], iso639_1: '' },
  { name: ['Iroquoian languages'], iso639_1: '' },
  { name: ['Lojban'], iso639_1: '' },
  { name: ['Judeo-Persian'], iso639_1: '' },
  { name: ['Judeo-Arabic'], iso639_1: '' },
  { name: ['Kara-Kalpak'], iso639_1: '' },
  { name: ['Kabyle'], iso639_1: '' },
  { name: ['Kachin', ' Jingpho'], iso639_1: '' },
  { name: ['Kamba'], iso639_1: '' },
  { name: ['Karen languages'], iso639_1: '' },
  { name: ['Kawi'], iso639_1: '' },
  { name: ['Kabardian'], iso639_1: '' },
  { name: ['Khasi'], iso639_1: '' },
  { name: ['Khoisan languages'], iso639_1: '' },
  { name: ['Khotanese', ' Sakan'], iso639_1: '' },
  { name: ['Kimbundu'], iso639_1: '' },
  { name: ['Konkani'], iso639_1: '' },
  { name: ['Kosraean'], iso639_1: '' },
  { name: ['Kpelle'], iso639_1: '' },
  { name: ['Karachay-Balkar'], iso639_1: '' },
  { name: ['Karelian'], iso639_1: '' },
  { name: ['Kru languages'], iso639_1: '' },
  { name: ['Kurukh'], iso639_1: '' },
  { name: ['Kumyk'], iso639_1: '' },
  { name: ['Kutenai'], iso639_1: '' },
  { name: ['Ladino'], iso639_1: '' },
  { name: ['Lahnda'], iso639_1: '' },
  { name: ['Lamba'], iso639_1: '' },
  { name: ['Lezghian'], iso639_1: '' },
  { name: ['Mongo'], iso639_1: '' },
  { name: ['Lozi'], iso639_1: '' },
  { name: ['Luba-Lulua'], iso639_1: '' },
  { name: ['Luiseno'], iso639_1: '' },
  { name: ['Lunda'], iso639_1: '' },
  { name: ['Luo (Kenya and Tanzania)'], iso639_1: '' },
  { name: ['Lushai'], iso639_1: '' },
  { name: ['Madurese'], iso639_1: '' },
  { name: ['Magahi'], iso639_1: '' },
  { name: ['Maithili'], iso639_1: '' },
  { name: ['Makasar'], iso639_1: '' },
  { name: ['Mandingo'], iso639_1: '' },
  { name: ['Austronesian languages'], iso639_1: '' },
  { name: ['Masai'], iso639_1: '' },
  { name: ['Moksha'], iso639_1: '' },
  { name: ['Mandar'], iso639_1: '' },
  { name: ['Mende'], iso639_1: '' },
  { name: ['Irish, Middle (900-1200)'], iso639_1: '' },
  { name: ["Mi'kmaq", ' Micmac'], iso639_1: '' },
  { name: ['Minangkabau'], iso639_1: '' },
  { name: ['Uncoded languages'], iso639_1: '' },
  { name: ['Mon-Khmer languages'], iso639_1: '' },
  { name: ['Manchu'], iso639_1: '' },
  { name: ['Manipuri'], iso639_1: '' },
  { name: ['Manobo languages'], iso639_1: '' },
  { name: ['Mohawk'], iso639_1: '' },
  { name: ['Mossi'], iso639_1: '' },
  { name: ['Multiple languages'], iso639_1: '' },
  { name: ['Munda languages'], iso639_1: '' },
  { name: ['Creek'], iso639_1: '' },
  { name: ['Mirandese'], iso639_1: '' },
  { name: ['Marwari'], iso639_1: '' },
  { name: ['Mayan languages'], iso639_1: '' },
  { name: ['Erzya'], iso639_1: '' },
  { name: ['Nahuatl languages'], iso639_1: '' },
  { name: ['North American Indian languages'], iso639_1: '' },
  { name: ['Neapolitan'], iso639_1: '' },
  {
    name: ['Low German', ' Low Saxon', ' German, Low', ' Saxon, Low'],
    iso639_1: '',
  },
  { name: ['Nepal Bhasa', ' Newari'], iso639_1: '' },
  { name: ['Nias'], iso639_1: '' },
  { name: ['Niger-Kordofanian languages'], iso639_1: '' },
  { name: ['Niuean'], iso639_1: '' },
  { name: ['Nogai'], iso639_1: '' },
  { name: ['Norse, Old'], iso639_1: '' },
  { name: ["N'Ko"], iso639_1: '' },
  { name: ['Nubian languages'], iso639_1: '' },
  {
    name: ['Classical Newari', ' Old Newari', ' Classical Nepal Bhasa'],
    iso639_1: '',
  },
  { name: ['Nyamwezi'], iso639_1: '' },
  { name: ['Nyankole'], iso639_1: '' },
  { name: ['Nyoro'], iso639_1: '' },
  { name: ['Nzima'], iso639_1: '' },
  { name: ['Osage'], iso639_1: '' },
  { name: ['Turkish, Ottoman (1500-1928)'], iso639_1: '' },
  { name: ['Otomian languages'], iso639_1: '' },
  { name: ['Papuan languages'], iso639_1: '' },
  { name: ['Pangasinan'], iso639_1: '' },
  { name: ['Pahlavi'], iso639_1: '' },
  { name: ['Pampanga', ' Kapampangan'], iso639_1: '' },
  { name: ['Papiamento'], iso639_1: '' },
  { name: ['Palauan'], iso639_1: '' },
  { name: ['Persian, Old (ca.600-400 B.C.)'], iso639_1: '' },
  { name: ['Philippine languages'], iso639_1: '' },
  { name: ['Phoenician'], iso639_1: '' },
  { name: ['Pohnpeian'], iso639_1: '' },
  { name: ['Prakrit languages'], iso639_1: '' },
  {
    name: ['Proven�al, Old (to 1500)', 'Occitan, Old (to 1500)'],
    iso639_1: '',
  },
  { name: ['Reserved for local use'], iso639_1: '' },
  { name: ['Rajasthani'], iso639_1: '' },
  { name: ['Rapanui'], iso639_1: '' },
  { name: ['Rarotongan', ' Cook Islands Maori'], iso639_1: '' },
  { name: ['Romance languages'], iso639_1: '' },
  { name: ['Romany'], iso639_1: '' },
  { name: ['Aromanian', ' Arumanian', ' Macedo-Romanian'], iso639_1: '' },
  { name: ['Sandawe'], iso639_1: '' },
  { name: ['Yakut'], iso639_1: '' },
  { name: ['South American Indian languages'], iso639_1: '' },
  { name: ['Salishan languages'], iso639_1: '' },
  { name: ['Samaritan Aramaic'], iso639_1: '' },
  { name: ['Sasak'], iso639_1: '' },
  { name: ['Santali'], iso639_1: '' },
  { name: ['Sicilian'], iso639_1: '' },
  { name: ['Scots'], iso639_1: '' },
  { name: ['Selkup'], iso639_1: '' },
  { name: ['Semitic languages'], iso639_1: '' },
  { name: ['Irish, Old (to 900)'], iso639_1: '' },
  { name: ['Sign Languages'], iso639_1: '' },
  { name: ['Shan'], iso639_1: '' },
  { name: ['Sidamo'], iso639_1: '' },
  { name: ['Siouan languages'], iso639_1: '' },
  { name: ['Sino-Tibetan languages'], iso639_1: '' },
  { name: ['Slavic languages'], iso639_1: '' },
  { name: ['Southern Sami'], iso639_1: '' },
  { name: ['Sami languages'], iso639_1: '' },
  { name: ['Lule Sami'], iso639_1: '' },
  { name: ['Inari Sami'], iso639_1: '' },
  { name: ['Skolt Sami'], iso639_1: '' },
  { name: ['Soninke'], iso639_1: '' },
  { name: ['Sogdian'], iso639_1: '' },
  { name: ['Songhai languages'], iso639_1: '' },
  { name: ['Sranan Tongo'], iso639_1: '' },
  { name: ['Serer'], iso639_1: '' },
  { name: ['Nilo-Saharan languages'], iso639_1: '' },
  { name: ['Sukuma'], iso639_1: '' },
  { name: ['Susu'], iso639_1: '' },
  { name: ['Sumerian'], iso639_1: '' },
  { name: ['Classical Syriac'], iso639_1: '' },
  { name: ['Syriac'], iso639_1: '' },
  { name: ['Tai languages'], iso639_1: '' },
  { name: ['Timne'], iso639_1: '' },
  { name: ['Tereno'], iso639_1: '' },
  { name: ['Tetum'], iso639_1: '' },
  { name: ['Tigre'], iso639_1: '' },
  { name: ['Tiv'], iso639_1: '' },
  { name: ['Tokelau'], iso639_1: '' },
  { name: ['Klingon', ' tlhIngan-Hol'], iso639_1: '' },
  { name: ['Tlingit'], iso639_1: '' },
  { name: ['Tamashek'], iso639_1: '' },
  { name: ['Tonga (Nyasa)'], iso639_1: '' },
  { name: ['Tok Pisin'], iso639_1: '' },
  { name: ['Tsimshian'], iso639_1: '' },
  { name: ['Tumbuka'], iso639_1: '' },
  { name: ['Tupi languages'], iso639_1: '' },
  { name: ['Altaic languages'], iso639_1: '' },
  { name: ['Tuvalu'], iso639_1: '' },
  { name: ['Tuvinian'], iso639_1: '' },
  { name: ['Udmurt'], iso639_1: '' },
  { name: ['Ugaritic'], iso639_1: '' },
  { name: ['Umbundu'], iso639_1: '' },
  { name: ['Undetermined'], iso639_1: '' },
  { name: ['Vai'], iso639_1: '' },
  { name: ['Votic'], iso639_1: '' },
  { name: ['Wakashan languages'], iso639_1: '' },
  { name: ['Wolaitta', ' Wolaytta'], iso639_1: '' },
  { name: ['Waray'], iso639_1: '' },
  { name: ['Washo'], iso639_1: '' },
  { name: ['Sorbian languages'], iso639_1: '' },
  { name: ['Kalmyk', ' Oirat'], iso639_1: '' },
  { name: ['Yao'], iso639_1: '' },
  { name: ['Yapese'], iso639_1: '' },
  { name: ['Yupik languages'], iso639_1: '' },
  { name: ['Zapotec'], iso639_1: '' },
  { name: ['Blissymbols', ' Blissymbolics', ' Bliss'], iso639_1: '' },
  { name: ['Zenaga'], iso639_1: '' },
  { name: ['Standard Moroccan Tamazight'], iso639_1: '' },
  { name: ['Zande languages'], iso639_1: '' },
  { name: ['Zuni'], iso639_1: '' },
  { name: ['No linguistic content', ' Not applicable'], iso639_1: '' },
  {
    name: ['Zaza', ' Dimili', ' Dimli', ' Kirdki', ' Kirmanjki', ' Zazaki'],
    iso639_1: '',
  },
];

const countries: Country[] = [
  { name: 'Afghanistan', code_2: 'AF' },
  { name: 'Åland Islands', code_2: 'AX' },
  { name: 'Albania', code_2: 'AL' },
  { name: 'Algeria', code_2: 'DZ' },
  { name: 'American Samoa', code_2: 'AS' },
  { name: 'Andorra', code_2: 'AD' },
  { name: 'Angola', code_2: 'AO' },
  { name: 'Anguilla', code_2: 'AI' },
  { name: 'Antarctica', code_2: 'AQ' },
  { name: 'Antigua and Barbuda', code_2: 'AG' },
  { name: 'Argentina', code_2: 'AR' },
  { name: 'Armenia', code_2: 'AM' },
  { name: 'Aruba', code_2: 'AW' },
  { name: 'Australia', code_2: 'AU' },
  { name: 'Austria', code_2: 'AT' },
  { name: 'Azerbaijan', code_2: 'AZ' },
  { name: 'Bahamas', code_2: 'BS' },
  { name: 'Bahrain', code_2: 'BH' },
  { name: 'Bangladesh', code_2: 'BD' },
  { name: 'Barbados', code_2: 'BB' },
  { name: 'Belarus', code_2: 'BY' },
  { name: 'Belgium', code_2: 'BE' },
  { name: 'Belize', code_2: 'BZ' },
  { name: 'Benin', code_2: 'BJ' },
  { name: 'Bermuda', code_2: 'BM' },
  { name: 'Bhutan', code_2: 'BT' },
  { name: 'Bolivia, Plurinational State of', code_2: 'BO' },
  { name: 'Bonaire, Sint Eustatius and Saba', code_2: 'BQ' },
  { name: 'Bosnia and Herzegovina', code_2: 'BA' },
  { name: 'Botswana', code_2: 'BW' },
  { name: 'Bouvet Island', code_2: 'BV' },
  { name: 'Brazil', code_2: 'BR' },
  { name: 'British Indian Ocean Territory', code_2: 'IO' },
  { name: 'Brunei Darussalam', code_2: 'BN' },
  { name: 'Bulgaria', code_2: 'BG' },
  { name: 'Burkina Faso', code_2: 'BF' },
  { name: 'Burundi', code_2: 'BI' },
  { name: 'Cambodia', code_2: 'KH' },
  { name: 'Cameroon', code_2: 'CM' },
  { name: 'Canada', code_2: 'CA' },
  { name: 'Cape Verde', code_2: 'CV' },
  { name: 'Cayman Islands', code_2: 'KY' },
  { name: 'Central African Republic', code_2: 'CF' },
  { name: 'Chad', code_2: 'TD' },
  { name: 'Chile', code_2: 'CL' },
  { name: 'China', code_2: 'CN' },
  { name: 'Christmas Island', code_2: 'CX' },
  { name: 'Cocos (Keeling) Islands', code_2: 'CC' },
  { name: 'Colombia', code_2: 'CO' },
  { name: 'Comoros', code_2: 'KM' },
  { name: 'Congo', code_2: 'CG' },
  { name: 'Congo, the Democratic Republic of the', code_2: 'CD' },
  { name: 'Cook Islands', code_2: 'CK' },
  { name: 'Costa Rica', code_2: 'CR' },
  { name: "Côte d'Ivoire", code_2: 'CI' },
  { name: 'Croatia', code_2: 'HR' },
  { name: 'Cuba', code_2: 'CU' },
  { name: 'Curaçao', code_2: 'CW' },
  { name: 'Cyprus', code_2: 'CY' },
  { name: 'Czech Republic', code_2: 'CZ' },
  { name: 'Denmark', code_2: 'DK' },
  { name: 'Djibouti', code_2: 'DJ' },
  { name: 'Dominica', code_2: 'DM' },
  { name: 'Dominican Republic', code_2: 'DO' },
  { name: 'Ecuador', code_2: 'EC' },
  { name: 'Egypt', code_2: 'EG' },
  { name: 'El Salvador', code_2: 'SV' },
  { name: 'Equatorial Guinea', code_2: 'GQ' },
  { name: 'Eritrea', code_2: 'ER' },
  { name: 'Estonia', code_2: 'EE' },
  { name: 'Ethiopia', code_2: 'ET' },
  { name: 'Falkland Islands (Malvinas)', code_2: 'FK' },
  { name: 'Faroe Islands', code_2: 'FO' },
  { name: 'Fiji', code_2: 'FJ' },
  { name: 'Finland', code_2: 'FI' },
  { name: 'France', code_2: 'FR' },
  { name: 'French Guiana', code_2: 'GF' },
  { name: 'French Polynesia', code_2: 'PF' },
  { name: 'French Southern Territories', code_2: 'TF' },
  { name: 'Gabon', code_2: 'GA' },
  { name: 'Gambia', code_2: 'GM' },
  { name: 'Georgia', code_2: 'GE' },
  { name: 'Germany', code_2: 'DE' },
  { name: 'Ghana', code_2: 'GH' },
  { name: 'Gibraltar', code_2: 'GI' },
  { name: 'Greece', code_2: 'GR' },
  { name: 'Greenland', code_2: 'GL' },
  { name: 'Grenada', code_2: 'GD' },
  { name: 'Guadeloupe', code_2: 'GP' },
  { name: 'Guam', code_2: 'GU' },
  { name: 'Guatemala', code_2: 'GT' },
  { name: 'Guernsey', code_2: 'GG' },
  { name: 'Guinea', code_2: 'GN' },
  { name: 'Guinea-Bissau', code_2: 'GW' },
  { name: 'Guyana', code_2: 'GY' },
  { name: 'Haiti', code_2: 'HT' },
  { name: 'Heard Island and McDonald Islands', code_2: 'HM' },
  { name: 'Holy See (Vatican City State)', code_2: 'VA' },
  { name: 'Honduras', code_2: 'HN' },
  { name: 'Hong Kong', code_2: 'HK' },
  { name: 'Hungary', code_2: 'HU' },
  { name: 'Iceland', code_2: 'IS' },
  { name: 'India', code_2: 'IN' },
  { name: 'Indonesia', code_2: 'ID' },
  { name: 'Iran, Islamic Republic of', code_2: 'IR' },
  { name: 'Iraq', code_2: 'IQ' },
  { name: 'Ireland', code_2: 'IE' },
  { name: 'Isle of Man', code_2: 'IM' },
  { name: 'Israel', code_2: 'IL' },
  { name: 'Italy', code_2: 'IT' },
  { name: 'Jamaica', code_2: 'JM' },
  { name: 'Japan', code_2: 'JP' },
  { name: 'Jersey', code_2: 'JE' },
  { name: 'Jordan', code_2: 'JO' },
  { name: 'Kazakhstan', code_2: 'KZ' },
  { name: 'Kenya', code_2: 'KE' },
  { name: 'Kiribati', code_2: 'KI' },
  { name: "Korea, Democratic People's Republic of", code_2: 'KP' },
  { name: 'Korea, Republic of', code_2: 'KR' },
  { name: 'Kuwait', code_2: 'KW' },
  { name: 'Kyrgyzstan', code_2: 'KG' },
  { name: "Lao People's Democratic Republic", code_2: 'LA' },
  { name: 'Latvia', code_2: 'LV' },
  { name: 'Lebanon', code_2: 'LB' },
  { name: 'Lesotho', code_2: 'LS' },
  { name: 'Liberia', code_2: 'LR' },
  { name: 'Libya', code_2: 'LY' },
  { name: 'Liechtenstein', code_2: 'LI' },
  { name: 'Lithuania', code_2: 'LT' },
  { name: 'Luxembourg', code_2: 'LU' },
  { name: 'Macao', code_2: 'MO' },
  { name: 'Macedonia, the former Yugoslav Republic of', code_2: 'MK' },
  { name: 'Madagascar', code_2: 'MG' },
  { name: 'Malawi', code_2: 'MW' },
  { name: 'Malaysia', code_2: 'MY' },
  { name: 'Maldives', code_2: 'MV' },
  { name: 'Mali', code_2: 'ML' },
  { name: 'Malta', code_2: 'MT' },
  { name: 'Marshall Islands', code_2: 'MH' },
  { name: 'Martinique', code_2: 'MQ' },
  { name: 'Mauritania', code_2: 'MR' },
  { name: 'Mauritius', code_2: 'MU' },
  { name: 'Mayotte', code_2: 'YT' },
  { name: 'Mexico', code_2: 'MX' },
  { name: 'Micronesia, Federated States of', code_2: 'FM' },
  { name: 'Moldova, Republic of', code_2: 'MD' },
  { name: 'Monaco', code_2: 'MC' },
  { name: 'Mongolia', code_2: 'MN' },
  { name: 'Montenegro', code_2: 'ME' },
  { name: 'Montserrat', code_2: 'MS' },
  { name: 'Morocco', code_2: 'MA' },
  { name: 'Mozambique', code_2: 'MZ' },
  { name: 'Myanmar', code_2: 'MM' },
  { name: 'Namibia', code_2: 'NA' },
  { name: 'Nauru', code_2: 'NR' },
  { name: 'Nepal', code_2: 'NP' },
  { name: 'Netherlands', code_2: 'NL' },
  { name: 'New Caledonia', code_2: 'NC' },
  { name: 'New Zealand', code_2: 'NZ' },
  { name: 'Nicaragua', code_2: 'NI' },
  { name: 'Niger', code_2: 'NE' },
  { name: 'Nigeria', code_2: 'NG' },
  { name: 'Niue', code_2: 'NU' },
  { name: 'Norfolk Island', code_2: 'NF' },
  { name: 'Northern Mariana Islands', code_2: 'MP' },
  { name: 'Norway', code_2: 'NO' },
  { name: 'Oman', code_2: 'OM' },
  { name: 'Pakistan', code_2: 'PK' },
  { name: 'Palau', code_2: 'PW' },
  { name: 'Palestine, State of', code_2: 'PS' },
  { name: 'Panama', code_2: 'PA' },
  { name: 'Papua New Guinea', code_2: 'PG' },
  { name: 'Paraguay', code_2: 'PY' },
  { name: 'Peru', code_2: 'PE' },
  { name: 'Philippines', code_2: 'PH' },
  { name: 'Pitcairn', code_2: 'PN' },
  { name: 'Poland', code_2: 'PL' },
  { name: 'Portugal', code_2: 'PT' },
  { name: 'Puerto Rico', code_2: 'PR' },
  { name: 'Qatar', code_2: 'QA' },
  { name: 'Réunion', code_2: 'RE' },
  { name: 'Romania', code_2: 'RO' },
  { name: 'Russian Federation', code_2: 'RU' },
  { name: 'Rwanda', code_2: 'RW' },
  { name: 'Saint Barthélemy', code_2: 'BL' },
  { name: 'Saint Helena, Ascension and Tristan da Cunha', code_2: 'SH' },
  { name: 'Saint Kitts and Nevis', code_2: 'KN' },
  { name: 'Saint Lucia', code_2: 'LC' },
  { name: 'Saint Martin (French part)', code_2: 'MF' },
  { name: 'Saint Pierre and Miquelon', code_2: 'PM' },
  { name: 'Saint Vincent and the Grenadines', code_2: 'VC' },
  { name: 'Samoa', code_2: 'WS' },
  { name: 'San Marino', code_2: 'SM' },
  { name: 'Sao Tome and Principe', code_2: 'ST' },
  { name: 'Saudi Arabia', code_2: 'SA' },
  { name: 'Senegal', code_2: 'SN' },
  { name: 'Serbia', code_2: 'RS' },
  { name: 'Seychelles', code_2: 'SC' },
  { name: 'Sierra Leone', code_2: 'SL' },
  { name: 'Singapore', code_2: 'SG' },
  { name: 'Sint Maarten (Dutch part)', code_2: 'SX' },
  { name: 'Slovakia', code_2: 'SK' },
  { name: 'Slovenia', code_2: 'SI' },
  { name: 'Solomon Islands', code_2: 'SB' },
  { name: 'Somalia', code_2: 'SO' },
  { name: 'South Africa', code_2: 'ZA' },
  { name: 'South Georgia and the South Sandwich Islands', code_2: 'GS' },
  { name: 'South Sudan', code_2: 'SS' },
  { name: 'Spain', code_2: 'ES' },
  { name: 'Sri Lanka', code_2: 'LK' },
  { name: 'Sudan', code_2: 'SD' },
  { name: 'Suriname', code_2: 'SR' },
  { name: 'Svalbard and Jan Mayen', code_2: 'SJ' },
  { name: 'Swaziland', code_2: 'SZ' },
  { name: 'Sweden', code_2: 'SE' },
  { name: 'Switzerland', code_2: 'CH' },
  { name: 'Syrian Arab Republic', code_2: 'SY' },
  { name: 'System Test Market', code_2: 'ZZ' },
  { name: 'Taiwan, Province of China', code_2: 'TW' },
  { name: 'Tajikistan', code_2: 'TJ' },
  { name: 'Tanzania, United Republic of', code_2: 'TZ' },
  { name: 'Thailand', code_2: 'TH' },
  { name: 'Timor-Leste', code_2: 'TL' },
  { name: 'Togo', code_2: 'TG' },
  { name: 'Tokelau', code_2: 'TK' },
  { name: 'Tonga', code_2: 'TO' },
  { name: 'Trinidad and Tobago', code_2: 'TT' },
  { name: 'Tunisia', code_2: 'TN' },
  { name: 'Turkey', code_2: 'TR' },
  { name: 'Turkmenistan', code_2: 'TM' },
  { name: 'Turks and Caicos Islands', code_2: 'TC' },
  { name: 'Tuvalu', code_2: 'TV' },
  { name: 'Uganda', code_2: 'UG' },
  { name: 'Ukraine', code_2: 'UA' },
  { name: 'United Arab Emirates', code_2: 'AE' },
  { name: 'United Kingdom', code_2: 'GB' },
  { name: 'United States', code_2: 'US' },
  { name: 'United States Minor Outlying Islands', code_2: 'UM' },
  { name: 'Uruguay', code_2: 'UY' },
  { name: 'Uzbekistan', code_2: 'UZ' },
  { name: 'Vanuatu', code_2: 'VU' },
  { name: 'Venezuela, Bolivarian Republic of', code_2: 'VE' },
  { name: 'Viet Nam', code_2: 'VN' },
  { name: 'Virgin Islands, British', code_2: 'VG' },
  { name: 'Virgin Islands, U.S.', code_2: 'VI' },
  { name: 'Wallis and Futuna', code_2: 'WF' },
  { name: 'Western Sahara', code_2: 'EH' },
  { name: 'Yemen', code_2: 'YE' },
  { name: 'Zambia', code_2: 'ZM' },
  { name: 'Zimbabwe', code_2: 'ZW' },
];

export const getLanguages = () => languages;

export const getCountries = () => countries;
